
import { defineComponent } from "vue";

import Template from "@/components/Templates/index.vue";
import Gallery from "@/components/Gallery/Template1/index.vue";
import { GALLERY_ROUTE_NAMES } from "@/ts/enum";

export default defineComponent({
  name: GALLERY_ROUTE_NAMES.GALLERY_POYANIL,
  components: {
    Template,
    Gallery,
  },
});
